import { isString, isArray } from './DataUtils';

export const Element = selector => {
  return document.querySelector(selector);
};

export const addClassTo = (item, _class) =>
{
  console.log(` <| adding ${ _class } to ${  item } |> `, )
  if ( item && _class ) {
    let selector = item[0];
    let part = item.split(selector);
    let selectorBody = part[1];
    if (selector === `.`) {
      let elements = document.getElementsByClassName(selectorBody);
      elements && elements.length && elements.forEach(el => el.classList.add( _class ))
    }
    else if (selector === `#`) {
      let el = document.getElementById(selectorBody);
      el && el.classList.add(_class)
    }
    else {
      document.querySelector(item).classList.add(_class);
    }
  }
};

export const removeClassFrom = ( item, _class ) =>
{
  console.log(` <| removing ${ _class } from ${  item } |> `, )
  if ( item && _class ) {
    let selector = item[0];
    let part = item.split(selector);
    let selectorBody = part[1];
    if (selector === `.`) {
      let elements = document.getElementsByClassName(selectorBody);
      elements.length && elements.forEach(el => el.classList.remove( _class ))
    }
    else if (selector === `#`) {
      let el = document.getElementById(selectorBody);
      el && el.classList.remove(_class)
    }
    else {
      document.querySelector(item).classList.remove( _class );
    }
  }
};

var divs = document.querySelectorAll( '.model' );
for ( var i = 0; i < divs.length; i++ ) {
  divs[ i ].classList.add('new-class');
}

export const hasClass = (element, className) =>
{
  return (' ' + Element(element).className + ' ').indexOf(' ' + className+ ' ') > -1;
};

export const animate = ( element, behavior ) =>
{
  if ( element && behavior ) {
    if (isString( behavior ))
      addClassTo( element, behavior );
    else if (isArray( behavior ))
      behavior.map(b => addClassTo( element, b ));
  }
};

export const scrollElementToBottom = ( selector, pixels ) =>
{
  if ( Element( selector )) {
    Element( selector ).scrollTop =
      pixels ?
        Element( selector ).scrollTop + pixels :
        Element( selector ).scrollHeight;
  }
}

export const scrollElementToTop = ( selector, pixels ) =>
{
  if ( Element( selector )) {
    Element( selector ).scrollTop =
      pixels ? Element( selector ).scrollTop + pixels : 0;
  }
}